module.exports = __webpack_public_path__ + "media/images/signatures/zsofi_signature_black-ade43e8aebb68866aebb340062ee30ec.png";